import { Component, HostListener, OnInit } from '@angular/core';
import { MessagingService } from '../services/messaging/messaging.service';

@Component({
    selector: 'app-layout',
    templateUrl: './layout.component.html',
    styleUrls: ['./layout.component.scss']
})
export class LayoutComponent implements OnInit {

    constructor(private messagingService: MessagingService) { }

    ngOnInit() {
    }


    @HostListener('window:focus', ['$event'])
    onFocused(event) {
        this.messagingService.requestPermission();
    }

}
